export default __webpack_public_path__ + "static/media/srikant.9672fc12.jpg";